import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import "./warningBanner.scss";

/**
 * Warning banner component for push notification settings
 * @param {string} message - Warning message text
 * @param {string} margin - Margin top and bottom
 */
const WarningBanner = ({ message, margin }) => {
    return (
        <div className="warning-banner" style={{ margin: margin }}>
            <FontAwesomeIcon
                icon={faCircleExclamation}
                className="warning-icon"
            />
            <span className="warning-message">{message}</span>
        </div>
    );
};

export default WarningBanner;
